import * as React from 'react';
const ScottatureIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M94.83 146.4c0-4.3-.11-11.4-1.72-12.03-17.61-6.87-16.03-25.06-30.92-36.09 6.87-12.03 19.75 10.31 24.05 10.31 5.44-15.9-9.88-46.4 0-46.4 4.01 0 7.93 25.32 11.22 25.32s-.7-33.92 7.67-33.92c6.87 0 .36 29.2 4.51 33.35 5.44-.14 3.08-28.19 12.67-28.19 6.01 0-3.95 31.68 0 30.93 3 0 8.3-20.62 13.74-20.62 1.82 0 1.82 1.55 1.72 3.99-.34 8.32-8.59 27-8.59 30.38 0 .87 0 1.75-.03 2.65"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="M132.75 132.38c0 7.67-6.22 13.89-13.89 13.89-4.54 0-8.87-2.28-11.44-6.01-3.15-4.57-2.56-10.18-.48-15.09 2.56-6.05 6.4-11.58 8.21-17.89 4.97 4.91 7.5 9.96 8.76 16.27.98-2.51 1.86-5.06 1.81-7.75 4.11 4.26 7.03 10.67 7.03 16.58"
      className="prefix__cls-1"
    />
    <path
      d="M113.77 143.16c-.65-1.71-.4-3.64.19-5.38s1.5-3.33 2.23-5.01 1.26-3.51 1.02-5.32c2.26 1.05 4.09 2.92 5.3 5.1s1.83 4.65 2.03 7.14c.13 1.62.04 3.39-.98 4.66-2.37 2.94-8.41 2.47-9.79-1.18Z"
      className="prefix__cls-1"
    />
  </svg>
);
export default ScottatureIcon;
